import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { ServiceGroupRecord, ServiceRecord, PaymentRecord, PaymentType, DataService } from '@core/services/data.service';
import { GroupsService } from '@core/services/groups.service';
import { ServicesService } from '@core/services/services.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { ModalService } from '@common/services/modal.service';
import { CalendarComponent } from '@common/UI/calendar/calendar.component';

@Component({
  templateUrl: './service-payment-editor.component.html',
  styleUrls: ['./service-payment-editor.component.scss']
})
export class ServicePaymentEditorComponent implements OnInit {

  constructor(private ds: DataService, private ss: ServicesService, private gs: GroupsService, private sync: SynchronizationService, private modal: ModalService) { }

  public update = new EventEmitter<PaymentRecord>();

  public services: ServiceRecord[] = [];
  public groups: ServiceGroupRecord[] = [];

  public get service(): number {
    return this.payment.PartnerID;
  }

  public set service(value: number) {
    this.payment.PartnerID = value;
  }

  private _group: number = 0;

  public get group(): number {
    return this._group;
  }

  public editDate() {
    let ref = this.modal.show(CalendarComponent, { state: { selected: new Date(this.payment.Stamp) }, ignoreBackdropClick: true });

    ref.content.change.subscribe(date => {
      this.payment.Stamp = date.getTime();
      ref.hide();
    });  
  }


  public set group(value: number) {

    if (value != this._group) {
      this.payment.PartnerID = 0;
      this.services = this.ss.getByGroup(value);
    }

    this._group = value;
  }

  @Input()
  public payment: PaymentRecord = null;
  private original: PaymentRecord = null;

  public get amount(): number {
    return this.payment.SendAmount;
  }

  public set amount(value: number) {
    this.payment.SendAmount = this.payment.ReceiveAmount = value;
  }

  public get type(): "income" | "expense" {
    return this.payment.Type == PaymentType.Income + PaymentType.Service ? 'income' : 'expense';
  }

  public get savable(): boolean {
    return this.edited && this.payment.SendAmount > 0 && this.payment.ReceiveAmount > 0 && this.payment.PartnerID > 0 && this.payment.Notes.trim().length > 0;
  }

  public get saving(): boolean {
    return !this.modal.of(this).closable;
  }

  public get edited(): boolean {
    return this.original.SendAmount != this.payment.SendAmount || this.original.ReceiveAmount != this.payment.ReceiveAmount || this.original.PartnerID != this.payment.PartnerID || this.original.Notes.trim() != this.payment.Notes.trim() || this.original.Stamp != this.payment.Stamp;
  }

  ngOnInit(): void {

    this.sync.when(ServicesService, GroupsService).commit(() => {
      this.groups = this.gs.all.order(i => i.Name);

      this.payment = { ...this.payment };
      this.original = { ...this.payment };

      if (this.payment.PartnerID > 0) {
        this._group = this.ss.get(this.payment.PartnerID).GroupID;
        this.services = this.ss.getByGroup(this._group);
      }

    });       
  }

  public close() {

    this.modal.of(this).hide();
  } 

  public save() {
    this.modal.closable(false);
    this.payment.Notes = this.payment.Notes.trim();

    this.ds.payments(this.payment.ID > 0 ? 'update' : 'create', this.payment).subscribe(payments => {

      if (payments && payments.length == 1) {
        this.payment = payments[0];
        this.original = { ... this.payment }

        this.update.emit(this.payment)
      }

      this.modal.closable(true);
    });
  }

  public confirm() {
    this.modal.closable(false);

    this.ds.payments('confirm', this.payment).subscribe(payments => {

      if (payments && payments.length == 1) {
        this.payment = payments[0];
        this.original = { ... this.payment }
        this.close();

        this.update.emit(this.payment)
      }

      this.modal.closable(true);
    });
  }

  public cancel() {
    this.modal.closable(false);

    this.ds.payments('cancel', this.payment).subscribe(payments => {

      if (payments && payments.length == 1) {
        this.payment = payments[0];
        this.original = { ... this.payment }
        this.close();

        this.update.emit(this.payment)
      }

      this.modal.closable(true);
    });
  }
}
